<template>
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-12 mt-3">
        <sale-package v-if="getSaleState == 0"></sale-package>
        <sale-member v-if="getSaleState == 1"></sale-member>
        <sale-payment v-if="getSaleState == 2"></sale-payment>
        <sale-confirm v-if="getSaleState == 3"></sale-confirm>

        <div>
          <modals-container />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
import SalePackage from "./SalePackage.vue";
import SaleMember from "./SaleMember.vue";
import SalePayment from "./SalePayment.vue";
import SaleConfirm from "./SaleConfirm.vue";

export default {
  data() {
    return {
      currentStep: 0,
    };
  },
  components: {
    SalePackage,
    SaleMember,
    SalePayment,
    SaleConfirm,
  },
  computed: {
    ...mapGetters(["getSaleState"]),
    value() {
      return this.$store.state.counter;
    },
  },
  mounted() {
    //console.log("here");
    this.$store.dispatch("setSaleState", 0);
  },
  methods: {
    //...mapMutations([]),
    ...mapActions(["incrementCounter"]),
    bypassCounter(event) {
      this.$store.dispatch("bypassCounter", event.target.value);
    },
  },
};
</script>
